import * as React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './multicreatorStartDateSummary.module.scss';
import { SimpleDate } from '../../../../admin/components/date/TimeRange';

const EmptyBox = () => (
    <div styleName="empty-box">
        カレンダーから開始する日を<br />
        選択してください
    </div>
);

export const MulticreatorStartDateSummary = ({ date, onSubmit }) => {
    if (!date) {
        return <EmptyBox />;
    }
    return (
        <div styleName="box">
            <div styleName="title">受講開始日</div>
            <div styleName="body">
                <SimpleDate date={date} />
            </div>
            <div styleName="button-wrapper">
                <Button type="primary" id="default-box-submit" onClick={onSubmit}>
                    選択する
                </Button>
            </div>
        </div>
    );
};
